import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CurrencyRateReducer } from '../reducers';

export const selectCurrencyRateFeature = createFeatureSelector<CurrencyRateReducer.CurrencyRateState>(CurrencyRateReducer.featureName);

export const selectCurrencyRate = createSelector(selectCurrencyRateFeature, (state: CurrencyRateReducer.CurrencyRateState) => state.item);
